/**
 * Created by mac on 5/8/17.
 */

if (typeof cc === "undefined") {
    global.Base80 = require("./base80");
}

cleverapps.CODE_SUCCEED = 0;
cleverapps.CODE_FAILED = 1;
cleverapps.CODE_CANCELLED = 2;
cleverapps.CODE_PENDING = 3;

cleverapps.CODE_CANCELLED_FACEBOOK_DIALOG = 4201;

cleverapps.normalize = function (arr, ratio) {
    ratio = ratio || 1;

    let sum = 0;
    for (let i = 0; i < arr.length; i++) {
        sum += arr[i];
    }

    return arr.map((value) => value / sum * ratio);
};

/**
 * Parses parameters to a JS map<br/>
 * Supports both window.location.search and window.location.hash)
 * @param {String} [source=window.location.search] string to parse
 * @returns {Object}
 */
cleverapps.getRequestParameters = function (source, keepAsIs) {
    const res = {};
    let url = source || window.location.search;
    if (url) {
        url = url.substr(1); // Drop the leading '?' / '#'
        const nameValues = url.split("&");

        for (let i = 0; i < nameValues.length; i++) {
            const nameValue = nameValues[i].split("=");
            const name = nameValue[0];
            let value = nameValue[1] || "";
            if (!keepAsIs) {
                try {
                    value = decodeURIComponent(value.replace(/\+/g, " "));
                } catch (e) {
                    console.error(`getRequestParameters decodeURIComponent - ${value}`);
                }
            }
            res[name] = value;
        }
    }
    return res;
};

cleverapps.addSearchParams = function (url, searchParams) {
    const urlObj = new URL(url);
    const params = urlObj.searchParams;

    for (const param in searchParams) {
        params.set(param, searchParams[param]);
    }

    return urlObj.toString();
};

cleverapps.setRequestParameters = function (newParams) {
    let params = cleverapps.getRequestParameters();

    params = Object.assign(params, newParams);

    location.search = Object.keys(params).map((key) => {
        const value = params[key];

        return `${key}=${value}`;
    }).join("&");
};

cleverapps.isRumble = function () {
    return cleverapps.knockoutGame && cleverapps.knockoutGame.isRumble();
};

cleverapps.isKnockoutGame = function () {
    return cleverapps.config.regime === "knockout";
};

cleverapps.humanReadableNumber = function (episode, level) {
    let episodeNo = episode;
    let levelNo = level;

    if (typeof episode === "object") {
        let floatLevel = episode.floatLevel || 0;

        if (["merge", "merge2"].includes(cleverapps.config.type)) {
            return Math.ceil(floatLevel) + 1;
        }

        if (cleverapps.isKnockoutGame()) {
            floatLevel /= 6;
        } else {
            floatLevel /= 2;
        }
        episodeNo = Math.floor(floatLevel);
        levelNo = Math.round(Level.LEVELS_PER_EPISODE * (floatLevel - episodeNo));
    }

    return (parseInt(episodeNo) || 0) * Level.LEVELS_PER_EPISODE + levelNo + 1;
};

cleverapps.arrayFill = function (n, value) {
    const res = [];
    for (let i = 0; i < n; i++) {
        res.push(value);
    }
    return res;
};

cleverapps.formatAmount = function (amount) {
    if (amount < 1000) {
        return amount;
    }

    const thousands = Math.floor(amount / 1000);

    amount -= thousands * 1000;

    if (amount < 10) {
        amount = `00${amount}`;
    } else if (amount < 100) {
        amount = `0${amount}`;
    }

    const DELIMETER = " ";
    return thousands + DELIMETER + amount;
};

cleverapps.cmp = function (a, b) {
    a = JSON.stringify(a);
    b = JSON.stringify(b);

    return a === b;
};

cleverapps.loadSdk = function (path, options) {
    options.onSuccessOnce = options.onSuccessOnce || cleverapps.once(options.onSuccess);
    options.onFailureOnce = options.onFailureOnce || cleverapps.once(options.onFailure);

    const onSuccess = options.onSuccessOnce;
    const onFailure = options.onFailureOnce;

    if (options.attempt === undefined) {
        options.attempt = 3;
    }

    const script = document.createElement("script");
    if (options.crossorigin !== false) {
        script.setAttribute("crossorigin", "anonymous");
    }
    script.setAttribute("type", "text/javascript");
    script.setAttribute("src", path);
    if (options.attrs) {
        Object.keys(options.attrs).forEach((attrName) => {
            script.setAttribute(attrName, options.attrs[attrName]);
        });
    }

    let loadTimeout;

    const onFailureCallback = function () {
        clearTimeout(loadTimeout);
        script.onload = undefined;
        script.onerror = undefined;

        if (options.attempt > 1) {
            if (document.body.contains(script)) {
                document.body.removeChild(script);
            }
            options.attempt--;
            cleverapps.loadSdk(path, options);
        } else {
            onFailure();
        }
    };

    script.onload = function () {
        clearTimeout(loadTimeout);
        onSuccess();
    };
    script.onerror = onFailureCallback;
    loadTimeout = setTimeout(onFailureCallback, 30000);

    document.body.appendChild(script);
};

cleverapps.getFrameData = function (baseUrl, options) {
    options = options || {};

    const prefix = options.prefix || cleverapps.config.name;
    const timeout = options.timeout || 10000;
    const callback = cleverapps.waitNoMore(timeout, options.callback || (() => {}));

    const iframe = document.createElement("iframe");
    iframe.src = `${baseUrl}cleverapps/res/getdata.html?prefix=${prefix}&t=${Date.now()}`;
    iframe.style = "display: none;";
    document.body.appendChild(iframe);

    const listener = function (event) {
        console.log("receive message", event);

        const frameData = event && event.data && event.data.frameData;
        if (!frameData) {
            return;
        }

        console.log("Message received from the child: ", frameData);

        window.removeEventListener("message", listener);
        document.body.removeChild(iframe);

        callback(frameData);
    };

    window.addEventListener("message", listener);
};

cleverapps.setUrlHash = function (data) {
    const params = cleverapps.getRequestParameters(window.location.hash);

    for (const key in data) {
        const value = data[key];

        if (value === undefined) {
            delete params[key];
        } else {
            params[key] = value;
        }
    }

    window.location.hash = cleverapps.toUrlHash(params);
};

cleverapps.toUrlHash = function (data) {
    return Object.keys(data).map((objectKey) => `${objectKey}=${data[objectKey]}`).join("&");
};

cleverapps.INTERVALS = {
    second: 1,
    minute: 60,
    hour: 3600,
    day: 86400,
    week: 7 * 86400,
    month: 30 * 86400
};

cleverapps.padZeroes = function (num, size) {
    let s = `${num}`;
    while (s.length < size) {
        s = `0${s}`;
    }
    return s;
};

cleverapps.convertToTimezone = function (utcString) {
    const utc = new Date(utcString);
    utc.setMinutes(utc.getMinutes() + utc.getTimezoneOffset());
    return utc;
};

cleverapps.convertFromTimezone = (date) => {
    if (date) {
        date = new Date(date.toString());
        date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
    }
    return date;
};

cleverapps.compactTime = function (time, options) {
    if (!time) {
        return time;
    }

    const precision = options && options.seconds ? 1000 : 60000;

    return Math.max(Math.round((time - cleverapps.ZERO_DATE) / precision), 0);
};

cleverapps.expandTime = function (time, options) {
    if (!time || time > cleverapps.ZERO_DATE) {
        return time;
    }
    const precision = options && options.seconds ? 1000 : 60000;

    return time * precision + cleverapps.ZERO_DATE;
};

cleverapps.parseInterval = function (intervalStr) {
    const value = parseInt(intervalStr) * 1000;

    for (const name in cleverapps.INTERVALS) {
        if (intervalStr.indexOf(name) !== -1) {
            const period = cleverapps.INTERVALS[name];
            return value * period;
        }
    }

    return value;
};

cleverapps.getCooldownStartTime = function (timeout) {
    if (typeof timeout === "string") {
        timeout = cleverapps.parseInterval(timeout);
    }

    if (timeout >= cleverapps.parseInterval("1 day")) {
        // the cooldown is counted from the start of the current day; on a DST transition the day is 23 or 25 hours
        // long, so compute "00:00 + timeout" in local time and subtract the timeout to get the start
        return new Date().setHours(0, 0, 0, timeout) - timeout;
    }

    return Date.now();
};

cleverapps.once = function (func) {
    return function (...args) {
        if (func) {
            const oldFunc = func;
            func = undefined;
            return oldFunc.apply(this, args);
        }
    };
};

cleverapps.shuffleInPlace = function (a) {
    for (let i = a.length - 1; i > 0; i--) {
        const s = PseudoRandom.GET().random(i);
        const tmp = a[i];
        a[i] = a[s];
        a[s] = tmp;
    }
    return a;
};

cleverapps.extractDateFromDateTime = function (datetime) {
    return new Date(datetime).setHours(0, 0, 0, 0);
};

cleverapps.extractNumber = function (str) {
    if (!str) {
        return;
    }

    let digits = "";
    for (let i = 0; i < str.length; i++) {
        const ch = str.charAt(i);
        if (ch.match(/\d+/g)) {
            digits += ch;
        } else if (ch === "," || ch === ".") {
            digits += ".";
        }
    }
    return digits.indexOf(".") !== -1 ? parseFloat(digits) : parseInt(digits);
};

cleverapps.override = function (target, source) {
    for (const i in source) {
        const v1 = target[i];
        const v2 = source[i];

        if (typeof cc !== "undefined" && v1 instanceof cc.Color) {
            target[i] = v2;
        } else if (Array.isArray(v1) && Array.isArray(v2)) {
            target[i] = v2;
        } else if (typeof v1 === "object" && typeof v2 === "object") {
            cleverapps.override(v1, v2);
        } else {
            target[i] = v2;
        }
    }
    return target;
};

cleverapps.increaseStylesByKoef = function (target, koef) {
    for (const i in target) {
        const value = target[i];
        if (typeof value === "number") {
            if (Array.isArray(target)) {
                continue;
            }
            if (cleverapps.UI.needUpdateSizes(target, i, value)) {
                target[i] *= koef;
                target[i] = Math.round(target[i]);
            }
        } else if (typeof value === "object") {
            if (cleverapps.UI.needUpdateSizes(target, i, value)) {
                cleverapps.increaseStylesByKoef(value, koef);
            }
        }
    }
};

cleverapps.overrideStyles = function (target, source, clone) {
    if (target === undefined || source === undefined) {
        console.log(target, source);
    }

    if (clone) {
        target = cleverapps.clone(target, true);
    }

    for (const i in source) {
        const v1 = target[i];
        const v2 = source[i];

        if (cleverapps.oneOf(v1, cc.Color, VirtualResource) || v1 && v1.fnt || v1 && v1.tmplt) {
            target[i] = v2;
        } else if (Array.isArray(v2)) {
            target[i] = v2;
        } else if (typeof v1 === "object" && typeof v2 === "object") {
            cleverapps.overrideStyles(v1, v2);
        } else {
            target[i] = v2;
        }
    }
    return target;
};

cleverapps.overrideColors = function (target, source) {
    const isColor = function (obj) {
        return obj instanceof cc.Color
            || connector.info.isNative && obj && obj.r !== undefined && obj.g !== undefined && obj.b !== undefined && obj.a !== undefined;
    };

    for (const i in source) {
        const v1 = target[i];
        const v2 = source[i];

        if (v1 === undefined) {
            target[i] = v2;
        } else if (isColor(v1) && isColor(v2)) {
            v1.r = v2.r;
            v1.g = v2.g;
            v1.b = v2.b;
            v1.a = v2.a;
        } else if (typeof v1 === "object" && typeof v2 === "object") {
            cleverapps.overrideColors(v1, v2);
        } else {
            target[i] = v2;
        }
    }
    return target;
};

cleverapps.overrideFonts = function (target, source) {
    for (const i in source) {
        const v1 = target[i];
        const v2 = source[i];
        let was;

        if (v1 === undefined) {
            target[i] = v2;
        } else {
            if (cleverapps.config.debugMode) {
                was = JSON.stringify(v1);
            }
            if (v2.size) {
                v1.size = v2.size;
            }
            if (v2.color) {
                v1.color = v2.color;
            }
            if (v2.name) {
                v1.name = v2.name;
            }
            if (v2.font) {
                v1.font = v2.font;
            }
            if (v2.lineHeight) {
                v1.lineHeight = v2.lineHeight;
            }
            v1.stroke = v2.stroke;
            v1.shadow = v2.shadow;

            if (cleverapps.config.debugMode) {
                const become = JSON.stringify(v1);
                if (was === become) {
                    console.log(`WAS BECOME override ${i}`);
                    console.log(was, become);
                    throw `Unnecessary overrideFonts: ${i}`;
                }
            }
        }

        target[i].fnt = true;
    }
    return target;
};

cleverapps.installStyles = function (target, source) {
    return cleverapps.overrideStyles(target, cleverapps.UI.scaleStyles(source));
};

cleverapps.uninstallStyles = function (target, names) {
    names.forEach((name) => {
        delete target[name];
    });
};

cleverapps.installFonts = function (source) {
    return cleverapps.overrideFonts(cleverapps.styles.FONTS, cleverapps.UI.scaleStyles(source));
};

cleverapps.uninstallFonts = function (names) {
    cleverapps.uninstallStyles(cleverapps.styles.FONTS, names);
};

cleverapps.overrideTemplates = function (target, source) {
    for (const i in source) {
        const v1 = target[i];
        const v2 = source[i];

        if (v2 === undefined) {
            delete target[i];
        } else if (v1 === undefined) {
            target[i] = v2;
        } else {
            Object.assign(v1, v2);
        }

        if (target[i]) {
            target[i].tmplt = true;
        }
    }
    return target;
};

cleverapps.clone = function (object, recursive) {
    if (object === null) {
        return null;
    }

    if (typeof object !== "object") {
        return object;
    }

    if (typeof cc !== "undefined" && object instanceof cc.Color) {
        return cc.color(object);
    }

    if (typeof cc !== "undefined" && cleverapps.oneOf(object, Bundle, VirtualResource)) {
        return object;
    }

    let r;

    if (Array.isArray(object)) {
        r = [];
        for (let i = 0; i < object.length; i++) {
            if (recursive) {
                r.push(cleverapps.clone(object[i], true));
            } else {
                r.push(object[i]);
            }
        }
        return r;
    }

    if (cleverapps.config.debugMode && Object.getPrototypeOf(object) && Object.getPrototypeOf(object) !== Object.prototype) {
        cleverapps.throwAsync("Clone only simple objects");
    }

    r = {};
    for (const name in object) {
        if (object[name] && object[name].fnt) {
            r[name] = object[name];
        } else if (recursive) {
            if (cleverapps.config.debugMode && typeof cc !== "undefined" && object[name] instanceof cc.Node) {
                throw `clone node object with name - ${name}`;
            }
            r[name] = cleverapps.clone(object[name], true);
        } else {
            r[name] = object[name];
        }
    }
    return r;
};

cleverapps.accumulate = function (interval, callback) {
    let timeout = undefined;
    let self;
    let args;

    return function (...newArgs) {
        self = this;
        args = newArgs;

        if (timeout === undefined) {
            timeout = setTimeout(() => {
                clearTimeout(timeout);
                timeout = undefined;

                const s = self, a = args;
                self = undefined;
                args = undefined;

                callback.apply(s, a);
            }, interval);
        }
    };
};

cleverapps.extendFunc = function (superFunc, func) {
    return function (...args) {
        const oldSuper = this._super;
        this._super = superFunc;
        const res = func.apply(this, args);
        this._super = oldSuper;
        return res;
    };
};

cleverapps.throttle = function (delay, callback) {
    let timeout;

    return function (...args) {
        if (timeout) {
            return;
        }

        timeout = setTimeout(() => {
            timeout = undefined;
        }, delay);

        callback.apply(this, args);
    };
};

cleverapps.postpone = function (delay, callback) {
    let self;
    let args;
    let timeout;

    return function (...newArgs) {
        self = this;
        args = newArgs;

        clearTimeout(timeout);
        timeout = setTimeout(() => {
            callback.apply(self, args);
        }, delay);
    };
};

cleverapps.timeredThrottle = function (delay, callback) {
    let self, args, timeout;

    const exec = function () {
        if (timeout || !args) {
            return;
        }

        timeout = setTimeout(() => {
            timeout = undefined;
            exec();
        }, delay);

        const s = self, a = args;
        self = undefined;
        args = undefined;

        callback.apply(s, a);
    };

    return function (...newArgs) {
        self = this;
        args = newArgs;

        exec();
    };
};

cleverapps.oneOf = function (obj, ...arr) {
    const constructors = Array.isArray(arr[0]) ? arr[0] : arr;

    for (let i = 0; i < constructors.length; i++) {
        if (obj instanceof constructors[i]) {
            return true;
        }
    }

    return false;
};

cleverapps.createSet = function (array) {
    const res = {};
    array.forEach((item) => {
        res[item] = true;
    });
    return res;
};

cleverapps.contains = function (array1, array2, getKey) {
    getKey = getKey || function (item) {
        return item;
    };

    array1 = cleverapps.toArray(array1 || []).map(getKey);
    array2 = cleverapps.toArray(array2 || []).map(getKey);

    return array2.filter((item) => array1.indexOf(item) !== -1).length === array2.length;
};

cleverapps.equals = function (array1, array2) {
    return !cleverapps.substract(array1, array2).length && !cleverapps.substract(array2, array1).length;
};

cleverapps.substract = function (array1, array2, getKey) {
    getKey = getKey || function (item) {
        return item;
    };

    array1 = array1 || [];
    array2 = array2 || [];

    const array2Object = {};
    array2.forEach((item) => {
        array2Object[getKey(item)] = true;
    });

    return array1.filter((item) => array2Object[getKey(item)] === undefined);
};

cleverapps.intersect = function (array1, array2, getKey) {
    getKey = getKey || function (item) {
        return item;
    };

    array1 = cleverapps.toArray(array1 || []);
    array2 = cleverapps.toArray(array2 || []).map(getKey);

    const array2Object = {};
    array2.forEach((item) => {
        array2Object[item] = true;
    });

    return array1.filter((item) => array2Object[getKey(item)] !== undefined);
};

cleverapps.unique = function (array, getKey) {
    if (typeof Set !== "undefined" && typeof Array.from === "function" && !getKey) {
        return Array.from(new Set(array));
    }

    const added = {};
    const result = [];
    array.forEach((item) => {
        const key = getKey ? getKey(item) : item;
        if (added[key] !== true) {
            result.push(item);
            added[key] = true;
        }
    });
    return result;
};

cleverapps.callFunc = function (action) {
    action && action();
};

cleverapps.intervalToString = function (time, showHours) {
    if (showHours === undefined) {
        showHours = true;
    }

    const days = Math.floor(time / (1000 * 60 * 60 * 24));
    if (days >= 10) {
        return Messages.get("daysFullString", { day: days });
    }

    time = Math.ceil(time / 1000);
    let sec = time % 60;
    time = Math.floor(time / 60);
    let min = time % 60;
    let hr = Math.floor(time / 60);
    if (sec < 10) {
        sec = `0${sec}`;
    }
    if (min < 10) {
        min = `0${min}`;
    }
    if (hr > 24 || (hr === 24 && (min > 0 || sec > 0))) {
        const day = Math.floor(hr / 24);
        hr %= 24;
        if (hr === 0) {
            return Messages.get("daysString", { day });
        }
        return Messages.get("dayTimeString", { day, hr });
    }
    if (!showHours && (hr <= 24 && hr > 0)) {
        return Messages.get("hoursMinutesString", { hr, min });
    }
    if (hr < 10) {
        hr = `0${hr}`;
    }
    return `${(showHours ? (`${hr}:`) : "") + min}:${sec}`;
};

cleverapps.isStaging = function () {
    if (!location.host) {
        return false;
    }

    return !connector.info.isNative && cleverapps.config.debugMode && (location.host.includes("labsystech.ru") || location.host.includes("-staging."));
};

cleverapps.isLocalhost = function () {
    if (!location.hostname) {
        return false;
    }

    return !connector.info.isNative && (location.hostname === "localhost" || location.hostname === "127.0.0.1" || location.hostname.indexOf("192.168.") === 0);
};

cleverapps.isIFrame = function () {
    return window.top !== window.self;
};

cleverapps.toArray = function (array) {
    return Array.isArray(array) || array === undefined || array === null ? array : [array];
};

cleverapps.wait = function (n, callback) {
    if (n === 0) {
        callback();
        return;
    }

    let total = 0;
    return function () {
        total++;
        if (total === n) {
            callback();
        }
    };
};

cleverapps.waitNoMore = function (timeout, callback, timeoutError) {
    let waitTimeout = setTimeout(() => {
        console.log(`waitNoMore timeout: ${timeout}`);
        waitTimeout = undefined;
        if (timeoutError) {
            callback(timeoutError);
        } else {
            callback();
        }
    }, timeout);

    return function (...args) {
        if (waitTimeout !== undefined) {
            clearTimeout(waitTimeout);
            waitTimeout = undefined;
            callback.apply(this, args);
        }
    };
};

cleverapps.waiter = function (f) {
    let total = 0;

    const waiter = () => {
        let local = 1;
        ++total;

        return () => {
            if (local > 0) {
                --local;
                --total;

                if (total === 0 && f) {
                    f();
                    f = undefined;
                }
            }
        };
    };

    const release = waiter();
    setTimeout(() => release(), 0);

    return waiter;
};

cleverapps.throwAsync = function (message, error) {
    if (typeof message === "object" && message.group) {
        message = `REPORT: ${message.group.toUpperCase()} ${message.message}`;
    }

    message = connector.utils.stringify(message);

    try {
        message = decodeURIComponent(message);
    } catch (e) {
        console.error(`cleverapps.throwAsync decodeURIComponent - ${message}`);
    }

    error = error || new Error(message);
    error.message = message;

    if (connector.platform.oneOf(connector.WECHAT)) {
        window.onerror(message);
    } else {
        setTimeout(() => {
            throw error;
        }, 0);
    }
};

cleverapps.isNumber = function (value) {
    return typeof value === "string" && value && /^-?[0-9]+$/.test(value) || typeof value === "number" && !isNaN(value);
};

cleverapps.isEmpty = function (value) {
    if (value === null || value === undefined) {
        return true;
    }

    if (typeof value === "object") {
        for (const key in value) {
            if (Object.prototype.hasOwnProperty.call(value, key) && typeof value[key] !== "undefined") {
                return false;
            }
        }
        return true;
    }

    return false;
};

cleverapps.castType = function (value) {
    if (typeof value === "string" && cleverapps.isNumber(value)) {
        return parseInt(value);
    }
    return value;
};

cleverapps.rangeArray = function (a, b) {
    const l = [];
    for (let i = a; i <= b; i++) {
        l.push(i);
    }
    return l;
};

cleverapps.splitToChunks = function (array, chunks) {
    const batch = Math.ceil(array.length / chunks);
    const result = [];
    while (array.length > 0) {
        result.push(array.splice(0, batch));
    }
    return result;
};

cleverapps.splitToBatches = function (array, batch) {
    const result = [];
    while (array.length > 0) {
        result.push(array.splice(0, batch));
    }
    return result;
};

cleverapps.sign = function (value) {
    if (value < 0) {
        return -1;
    }
    if (value > 0) {
        return 1;
    }

    return 0;
};

cleverapps.clamp = function (value, min, max) {
    return Math.min(Math.max(min, value), max);
};

cleverapps.splitHalfByWord = function (string) {
    const middle = Math.floor(string.length / 2);
    let index = -1;
    for (let i = 0; i <= middle && index === -1; i++) {
        if (string.charAt(middle - i) === " ") {
            index = middle - i;
        } else if (string.charAt(middle + i) === " ") {
            index = middle + i;
        }
    }
    return index === -1 ? [string] : [string.substr(0, index), string.substr(index + 1)];
};

cleverapps.colorToHex = function (color) {
    // eslint-disable-next-line no-bitwise
    return ((color.r << 16) + (color.g << 8) + (color.b | 0));
};

cleverapps.hashCode = function (str) {
    if (str === undefined || str === null || typeof str === "number" && isNaN(str)) {
        return 0;
    }

    str += "";

    let hashCode = 0;

    for (let i = 0; i < str.length; i++) {
        // eslint-disable-next-line no-bitwise
        hashCode = ((hashCode << 5) - hashCode) + str.charCodeAt(i);
    }

    return hashCode;
};

cleverapps.truncateToBytes = function (str, maxBytes) {
    let bytes = 0;

    for (let i = 0; i < str.length; i++) {
        const code = str.charCodeAt(i);

        if (code < 0x80) {
            bytes += 1;
        } else if (code < 0x800) {
            bytes += 2;
        } else {
            bytes += 3;
        }

        if (bytes > maxBytes) {
            return str.slice(0, i);
        }
    }

    return str;
};

cleverapps.reverseObject = function (obj) {
    const result = {};

    for (const key in obj) {
        const value = obj[key];

        if (result[value] !== undefined) {
            throw `Not unique key - ${key}`;
        }

        result[value] = key;
    }

    return result;
};

cleverapps.validateEmail = function (email) {
    // https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address
    return /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(email);
};

cleverapps.fromBit = function (bits) {
    if (!bits) {
        return [];
    }

    bits = cleverapps.toArray(bits);

    const arr = [];
    let id;

    bits.forEach((bit, index) => {
        id = cleverapps.SYNCED_BITS * index;
        while (bit) {
            if (bit % 2) {
                arr.push(id);
            }
            bit = Math.floor(bit / 2);
            id++;
        }
    });
    return arr;
};

cleverapps.toBit = function (arr, syncedBits) {
    syncedBits = syncedBits || cleverapps.SYNCED_BITS;

    const length = Math.ceil(syncedBits / cleverapps.SYNCED_BITS);
    const bits = cleverapps.arrayFill(length, 0);
    let slot, maxSlot = 0, bit;

    arr.forEach((id) => {
        if (id >= syncedBits) {
            cleverapps.throwAsync(`${id} is bigger then ${syncedBits}`);
            return;
        }

        bit = id % cleverapps.SYNCED_BITS;
        slot = (id - bit) / cleverapps.SYNCED_BITS;
        bits[slot] += Math.pow(2, bit);

        maxSlot = Math.max(slot, maxSlot);
    });

    return length === 1 || maxSlot === 0 ? bits[0] : bits.slice(0, maxSlot + 1);
};

cleverapps.fromBitBase64 = (bits) => {
    const numbers = bits.split("").map((char) => Base80.expandNumber(char)).reverse();

    const arr = numbers.reduce((arr, number, slot) => {
        for (let bit = 0; bit < 6; bit++) {
            if (number & (1 << bit)) {
                arr.push(slot * 6 + bit);
            }
        }
        return arr;
    }, []);

    return arr;
};

cleverapps.toBitBase64 = (arr) => {
    const numbers = arr.reduce((numbers, id) => {
        const bit = id % 6;
        const slot = (id - bit) / 6;
        numbers[slot] = (numbers[slot] || 0) + (1 << bit);

        return numbers;
    }, []);

    let res = "";

    for (let i = 0; i < numbers.length; i++) {
        res = Base80.compactNumber(numbers[i] || 0) + res;
    }

    return res;
};

cleverapps.listToBit = function (list) {
    const res = {};
    for (const code in list) {
        const bit = cleverapps.toBit(Object.keys(list[code]));
        if (bit !== 0) {
            res[code] = bit;
        }
    }

    return res;
};

cleverapps.listFromBit = function (list) {
    const res = {};
    for (const code in list) {
        if (typeof list[code] === "object") {
            // old format
            res[code] = list[code];
        } else {
            res[code] = cleverapps.createSet(cleverapps.fromBit(list[code]));
        }
    }
    return res;
};

cleverapps.fakePromise = function () {
    const promise = function () {
        return promise;
    };

    promise.then = function () {
        return promise;
    };

    promise.catch = function () {
        return promise;
    };

    return promise;
};

cleverapps.getCanvas = function () {
    return document.getElementById("GameCanvas");
};

cleverapps.copyToClipboard = function (value, callback) {
    callback = callback || function () {
        cleverapps.notification.create("Copied to clipboard");
    };

    const onError = function () {
        setTimeout(() => {
            const text = document.createElement("textArea");
            text.value = value;
            text.style.hidden = true;
            document.body.appendChild(text);

            try {
                text.select();
                document.execCommand("copy");
                callback();
            } catch (err) {
                console.log("Couldn't copy text to clipboard:", value);
            }
            document.body.removeChild(text);
        }, 0);
    };

    try {
        if (connector.platform.oneOf(connector.WECHAT)) {
            wx.setClipboardData({
                data: value,
                success: function () {
                    callback();
                },
                fail: function (err) {
                    console.log("wx.setClipboardData fail", err);
                }
            });
        } else {
            window.navigator.clipboard.writeText(value).then(callback).catch(onError);
        }
    } catch (e) {
        onError();
    }
};

cleverapps.isNodeOrElement = function (o) {
    return (
        typeof Node === "object" ? o instanceof Node
            : o && typeof o === "object" && typeof o.nodeType === "number" && typeof o.nodeName === "string"
    ) || (
        typeof HTMLElement === "object" ? o instanceof HTMLElement
            : o && typeof o === "object" && o !== null && o.nodeType === 1 && typeof o.nodeName === "string"
    );
};

cleverapps.whenGameActiveListener = function (listener) {
    return function (...args) {
        const self = this;

        cleverapps.whenGameActive(() => {
            listener.apply(self, args);
        });
    };
};

cleverapps.whenGameActive = function (callback) {
    if (!cc.game.isPaused()) {
        callback();
    } else {
        cleverapps.timeouts.setTimeout(callback, 0);
    }
};

cleverapps.ZERO_DATE = (new Date("2020-01-01")).getTime();
cleverapps.SYNCED_BITS = 52;
cleverapps.EMPTY_FUNCTION = function () {};

const MaxInteractiveScale = function (node) {
    return Math.min(1.03, 1 + cleverapps.styles.UI.Button.interactiveScale / Math.max(node.width, node.height));
};

const BaseScale = function (node) {
    const x = node.baseScaleX || node.baseScale || 1;
    const y = node.baseScaleY || node.baseScale || 1;

    return { x, y };
};

if (typeof cc !== "undefined" && cleverapps.config.debugMode && cleverapps.getRequestParameters(window.location.hash).dropDebugMode !== undefined) {
    cleverapps.config.debugMode = false;
}

if (typeof cc === "undefined") {
    module.exports = cleverapps;
}
